import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '@/components/Loader';
import useNetwork from '@/hooks/useNetwork';
import useRouter from '@/hooks/useRouter';
import Navigation from '@/dialogs_common/Navigation';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import Form from './Form';

export default function Layout() {
  const { history, match } = useRouter();
  const currentUser = useUser();
  const project = useConnect('project.byId', {
    id: Number(match.params.projectId)
  });

  const network = useNetwork();

  const isEligibleForGrants = network?.data?.grants === 'Yes';

  if (project.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }
  const networkName = network?.data?.name ? `, ${network.data.name}, ` : '';

  return (
    <ParentLayout
      project={project}
      page="Resources"
      title="Are there additional resources you need to complete this project?"
      description={(
        <>
          These might include items, funds, or access to specific tools. While we can&apos;t
          guarantee CommunityShare{networkName}or a partner can meet these needs, it
          never hurts to broadcast your need! Be as specific as you can.
        </>
      )}
    >
      <Form
        user={currentUser}
        project={project}
        navigation={(
          <Navigation v5={true} activeStep={17} steps={19}/>
        )}
        onPrevious={() => history.push(Urls(project).DOCUMENTS)}
        onNext={() => isEligibleForGrants ?
          history.push(Urls(project).GRANT) :
          history.push(Urls(project).SEARCH_EXPLANATION)
        }
        onSkip={() => isEligibleForGrants ?
          history.push(Urls(project).GRANT) :
          history.push(Urls(project).SEARCH_EXPLANATION)
        }
        onExit={() => history.push(Urls(project).PROJECT_EDIT)}
      />
    </ParentLayout>
  );
};
